// extracted by css-extract-rspack-plugin
export default {"root":"root-iLTRf5","roothideStarters":"roothideStarters-drxlUw","rootnoPadding":"rootnoPadding-LZvIIh","freeBox":"freeBox-fc5kyb"};